import { createQuery } from './core';
// PUBLIC API
export const getAppConfig = createQuery('operations/get-app-config', ['AppConfig']);
// PUBLIC API
export const getUserById = createQuery('operations/get-user-by-id', ['User']);
// PUBLIC API
export const validateUser = createQuery('operations/validate-user', ['User']);
// PUBLIC API
export const getSubscriptions = createQuery('operations/get-subscriptions', []);
// PUBLIC API
export const getCustomer = createQuery('operations/get-customer', []);
// PUBLIC API
export const createPortal = createQuery('operations/create-portal', []);
// PUBLIC API
export const getOrCreateCustomer = createQuery('operations/get-or-create-customer', []);
// PUBLIC API
export const getAllOnboardingTasksByUser = createQuery('operations/get-all-onboarding-tasks-by-user', ['OnboardingTask']);
// PUBLIC API
export const getAllUsers = createQuery('operations/get-all-users', ['User']);
// PUBLIC API
export const getAllCollectionsOfUserForSpyview = createQuery('operations/get-all-collections-of-user-for-spyview', ['User', 'MiqCollection']);
// PUBLIC API
export const getAllCollectionsOfUser = createQuery('operations/get-all-collections-of-user', ['User', 'MiqCollection']);
// PUBLIC API
export const getEnrichmentJobsForCollection = createQuery('operations/get-enrichment-jobs-for-collection', ['User', 'MiqCollection', 'EnrichmentJob']);
// PUBLIC API
export const getCollectionById = createQuery('operations/get-collection-by-id', ['MiqCollection']);
// PUBLIC API
export const getAllPlans = createQuery('operations/get-all-plans', ['Plan']);
// PUBLIC API
export const getUserSubscriptions = createQuery('operations/get-user-subscriptions', ['UserSubscription', 'Plan', 'CreditBalance']);
// PUBLIC API
export const getUserSubscriptionsWithExpired = createQuery('operations/get-user-subscriptions-with-expired', ['UserSubscription', 'Plan', 'CreditBalance']);
// PUBLIC API
export const getEnrichmentTasks = createQuery('operations/get-enrichment-tasks', ['EnrichmentJob']);
// PUBLIC API
export const getEnrichmentTask = createQuery('operations/get-enrichment-task', ['EnrichmentJob']);
// PUBLIC API
export const getEnrichments = createQuery('operations/get-enrichments', ['EnrichmentValues', 'MarketFactsRadarMultiplier']);
// PUBLIC API
export const getEnrichment = createQuery('operations/get-enrichment', ['EnrichmentValues', 'MarketFactsRadarMultiplier']);
// PRIVATE API (used in SDK)
export { buildAndRegisterQuery } from './core';
//# sourceMappingURL=index.js.map